import { Splide } from "@splidejs/splide";
import '@splidejs/splide/css';
import { toggleClass } from "../utils";
document.addEventListener('DOMContentLoaded', function () {
    var sliderBannerElement = document.querySelector('.abi-whoweare');
    if (sliderBannerElement) {
        var sliderBanner = new Splide(sliderBannerElement, {
            type: 'slide',
            perPage: 1,
            pagination: true,
            mediaQuery: 'min',
            breakpoints: {
                1024: {
                    destroy: true,
                },
                767: {
                    perPage: 1,
                    // some sort of remount option here?
                },
            }
        });
        sliderBanner.mount();
    }
    /** Open more information */
    toggleClass({
        selectorHandler: ".abi-whoweare__data-items-item-view-button",
        selectorParentElement: ".abi-whoweare__data-items-item",
        selectorElementToAddClass: ".abi-whoweare__data-items-item-detail",
        toggleClasss: "active"
    });
    /** Close more information */
    toggleClass({
        selectorHandler: ".abi-whoweare__data-items-item-detail-button",
        selectorParentElement: ".abi-whoweare__data-items-item",
        selectorElementToAddClass: ".abi-whoweare__data-items-item-detail",
        toggleClasss: "active"
    });
});
